import React from "react";

export const COBRECBarra = ({
  recuperado,
  porcentaje,
  indicador,
  objetivo,
  clientes,
}) => {
  const formatmiles = (number) => {
    if (number <= 0) {
      number = 0;
    }
    return Math.floor((number ?? 0) / 1000).toLocaleString("en-US");
  };
  return (
    <div className="container-barra">
      <div className="container-barra-importes">
        <div>
          $ {formatmiles(recuperado)} | <strong>{porcentaje}%</strong>
        </div>
        <div>
          $ {formatmiles(objetivo)}
          {/* {clientes} clientes */}
        </div>
      </div>
      <div className="barra-progreso-contenedor">
        <div
          className="barra-progreso"
          style={{
            width: `${porcentaje >= 100 ? 100 : porcentaje}%`,
            backgroundColor:
              indicador === "V"
                ? "#4caf50"
                : (indicador = "A" >= 60 ? "#ffc107" : "#f44336"),
          }}
        ></div>
      </div>
    </div>
  );
};
